import { useEffect, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../../utils/api'
import { getMockListingOpenSlots } from '../../../../RentalPortalViewing.mocks'
import { toViewingFormSlotItems } from '../../../RentalPortalViewingFormModal.utils'

import { getHasLoadedSlots } from './useViewingFormSlotItems.utils'

export function useViewingFormSlotItems({ isSlotSource, listingId }) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const [loadedSlots, setLoadedSlots] = useState({
    items: EMPTY_LIST,
    listingId: null,
  })

  async function loadSlots() {
    return getMockListingOpenSlots({ listing_id: listingId })
      .then(response => {
        setLoadedSlots({
          items: toViewingFormSlotItems({
            items: getItemsFromIdwellApiResponse(response),
            locale,
            timezone,
          }),
          listingId,
        })
      })
      .catch(() => {
        setLoadedSlots({ items: EMPTY_LIST, listingId })
      })
  }

  useEffect(() => {
    if (listingId && isSlotSource) {
      loadSlots()
    }
  }, [isSlotSource, listingId])

  function handleReload() {
    setLoadedSlots({ items: EMPTY_LIST, listingId: null })

    loadSlots()
  }

  const hasLoadedSlots = getHasLoadedSlots({ listingId, loadedSlots })

  return {
    handleReload,
    isLoading: Boolean(listingId) && isSlotSource && !hasLoadedSlots,
    items: hasLoadedSlots ? loadedSlots.items : EMPTY_LIST,
  }
}
